import {ENDPOINT_ADMIN_ORDERED_TERMINALS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const {
  apiRequestAdmin,
} = require('../ws');


export function apiAdminOrderedTerminalsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    const items = [
      {
        id: '1',
        time: '2020-05-26T15:47',
        company_name: 'Lunu Solutions GmbH',
        username: 'Pavlo Denusyk',
        status: 'ordered',
        color: 'Deep Ocean',
        count: 12,
      },
      {
        id: '2',
        time: '2020-05-26T15:47',
        company_name: 'Lunu Solutions GmbH',
        username: 'Pavlo Denusyk',
        status: 'ordered',
        color: 'Deep Ocean',
        count: 12,
      },
      {
        id: '3',
        time: '2020-05-26T15:47',
        company_name: 'Lunu Solutions GmbH',
        username: 'Pavlo Denusyk',
        status: 'ordered',
        color: 'Deep Ocean',
        count: 12,
      },
    ];
    return CancelablePromise.delay(500, {
      list: items.slice(offset, offset + limit),
      count: items.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_ORDERED_TERMINALS_LIST, {
    ...params,
    offset,
    limit,
  });
}
